import { useEffect } from 'react';
import { SharedScreenName } from '../config/FlowTypes';
import { PAY_CONFIG } from '../config/PayConfig';
import { ActionType } from '../store/ActionTypes';
import { AppSelector, useAppDispatch, useAppStore } from '../store/Store';

export function useEnsureCurrentPageMatchesPayFlow(): boolean {
  const dispatch = useAppDispatch();
  const currentPage = useAppStore(AppSelector.currentPage);

  const isCurrentPageInPayFlow = PAY_CONFIG.screens.some(
    (screen) => screen.screenName === currentPage
  );

  useEffect(
    function ensureCurrentPageMatchesPayFlow() {
      if (!isCurrentPageInPayFlow) {
        dispatch({
          type: ActionType.SET_PAGE,
          page: SharedScreenName.Payment,
          resetHistory: true,
        });
      }
    },
    [dispatch, isCurrentPageInPayFlow]
  );

  return isCurrentPageInPayFlow;
}
